'use client'

import { Input } from '@vendure/shadcn/ui'
import { debounce } from 'lodash'
import { usePathname, useRouter, useSearchParams } from 'next/navigation'
import { useIntl } from 'react-intl'

export function HubListSearchInput() {
  const intl = useIntl()
  const searchParams = useSearchParams()
  const { replace } = useRouter()
  const pathname = usePathname()

  const handleSearchTerm = debounce((term: string) => {
    const params = new URLSearchParams(searchParams)
    params.set('page', '1')

    if (term) {
      params.set('search', term)
    } else {
      params.delete('search')
    }
    replace(`${pathname}?${params.toString()}`)
  }, 300)

  return (
    <Input
      placeholder={intl.formatMessage({
        id: 'hub.label.search',
      })}
      onInput={(e) => {
        handleSearchTerm(e.currentTarget.value)
      }}
    />
  )
}
